import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { deleteCommentBookmark } from '../../../api/comments';
import { REQUEST } from '../../../constants/request';
import { generateCommentCIDKey } from '../utils/generateCommentCIDKey';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { mergeCommentWithUserData } from '../../../utils/comments';

export const removeCommentBookmark = createAsyncThunk(
  'comments/removeCommentBookmark',
  async (commentData, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const [commentResponse, commentUserDaraResponse] =
        await deleteCommentBookmark(commentData, {
          cancelToken: source.token,
        });
      return mergeCommentWithUserData(commentResponse, commentUserDaraResponse);
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: ({ path }, { getState }) => {
      const commentCIDKey = generateCommentCIDKey(path);
      const { comments } = getState().comments;

      return (
        comments.comment.actions.bookmark.request[commentCIDKey]?.loading !==
        REQUEST.pending
      );
    },
  },
);

export const removeCommentBookmarkExtraReducers = {
  [removeCommentBookmark.pending]: (state, action) => {
    const commentCIDKey = generateCommentCIDKey(action.meta.arg.path);

    checkAndSetLoadingWithId(
      state.comments.comment.actions.bookmark.request,
      action,
      commentCIDKey,
    );
  },
  [removeCommentBookmark.fulfilled]: (state, action) => {
    const commentCIDKey = generateCommentCIDKey(action.meta.arg.path);

    onMatchedRequest(
      state.comments.comment.actions.bookmark.request[commentCIDKey],
      action,
      () => {
        state.comments.comment.byId[commentCIDKey] = action.payload;
      },
    );
  },
  [removeCommentBookmark.rejected]: (state, action) => {
    const commentCIDKey = generateCommentCIDKey(action.meta.arg.path);

    handleRequestRejection(
      state.comments.comment.actions.bookmark.request[commentCIDKey],
      action,
    );
  },
};
